import { gql } from "@apollo/client";

export const REMOVE_NARRATIVE_SEGMENT = gql`
  mutation removeNarrativeSegment($input: RemoveNarrativeSegmentInput!) {
    removeNarrativeSegment(input: $input) {
      clientMutationId
      errors
      narrativeSegmentUuid
    }
  }
`;
